import { render, staticRenderFns } from "./OrganizationSplashScreen.vue?vue&type=template&id=1a2fdb64"
import script from "./OrganizationSplashScreen.vue?vue&type=script&lang=ts"
export * from "./OrganizationSplashScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports